export const boxplotBundle = {
  all: { ko: "전체", en: "All", es: "Todo" },
  stats: {
    title: { ko: "통계", en: "Statistics", es: "Estadisticas" },
    max: { ko: "최대", en: "Max", es: "Max" },
    q3: { ko: "Q3", en: "Q3", es: "Q3" },
    median: { ko: "중앙", en: "Median", es: "Mediana" },
    q1: { ko: "Q1", en: "Q1", es: "Q1" },
    min: { ko: "최소", en: "Min", es: "Min" },
    outlier: { ko: "이상치", en: "Outlier", es: "Valor atipico" }
  }
}
